import { ErrorReason } from "@/pages/quiz/base/questions/sumsubAttachmentBlock/types";

const DEFAULT_ERROR_MESSAGE =
  "An unexpected error occurred. Please refresh the page and try again. If the problem persists, please contact support.";

export const ErrorMessageBasedOnReason = {
  [ErrorReason.CAMERA_PERMISSION_DENIED]:
    "Camera permission denied. Please refresh and give permission to use camera.",
  [ErrorReason.NO_TOKEN]:
    "No token found. Please refresh and try again. If the problem persists, please contact support.",
};

export const getErrorMessage = (reason: ErrorReason | undefined): string => {
  if (!reason) return DEFAULT_ERROR_MESSAGE;
  return ErrorMessageBasedOnReason[reason] || DEFAULT_ERROR_MESSAGE;
};
